import { c as _c } from "react/compiler-runtime";
import { usePageTransition } from "./usePageTransition";
import { usePreloader } from "./usePreloader";

/**
 * track if any loader is currently in progress
 *
 * this includes both the preloader and page transitions
 */
export const useLoadState = () => {
  const $ = _c(5);
  const {
    completed: preloaderFinished
  } = usePreloader();
  const {
    isAnimating: pageTransitionInProgress
  } = usePageTransition();
  const entering = !preloaderFinished || pageTransitionInProgress === "after";
  const leaving = pageTransitionInProgress === "before";
  const completed = preloaderFinished;
  const t0 = !entering && !leaving;
  let t1;
  if ($[0] !== completed || $[1] !== entering || $[2] !== leaving || $[3] !== t0) {
    t1 = {
      entering,
      leaving,
      completed,
      idle: t0
    };
    $[0] = completed;
    $[1] = entering;
    $[2] = leaving;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};